
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const url = window.location.origin;


let urlStates = `${url}/wp-json/wp/v2/departamento_ciudad/?per_page=99&_fields[]=name&_fields[]=id&_fields[]=parent&hide_empty=true`;
let globalCategories = '';
let allShops = '';

function getStatesAll() {
    const parentStates = globalCategories.filter(parents => parents.parent == 0);
    parentStates.forEach(ciudad => {
        const getContentCiudades = document.querySelector('.deparmentos--filter');

        const options = document.createElement('option');
        options.setAttribute("value", ciudad.id);
        options.classList.add('states-value');

        options.textContent = ciudad.name;
        getContentCiudades.appendChild(options);
    });
}

//add Ciudades
function getCityAll(id) {
    const getContentCiudades = document.querySelector('.form-control.ciudades--filter');
    let insertCities = `<option class="state-value" value="">Ciudades</option>`
    const citiesData = globalCategories.filter(parents => parents.parent == id);
    citiesData.forEach(ciudad => {
        insertCities += `<option class="state-value" value="${ciudad.id}">${ciudad.name}</option>`;
    })
    getContentCiudades.innerHTML = insertCities;
}


function onChangeListener() {
    const changeState = document.querySelector('.form-control.deparmentos--filter');
    changeState.addEventListener('change', (e) => {
        let valueParentState = e.target.value;
        getCityAll(valueParentState);
        printShops(valueParentState);
    });
}

//On change Ciudades
function onChangeListenerCiudades() {
    const changeState = document.querySelector('.form-control.ciudades--filter');
    changeState.addEventListener('change', (e) => {
        let valueParentState = e.target.value;
        printShops(valueParentState);
    });
}

//Get all shops list
function getShops() {
    let urlForCategories = `${url}/wp-json/wp/v2/list-post/?post-type=tiendas`;
    fetch(urlForCategories)
        .then(result => result.json())
        .then(data => {
            allShops = data;
            printShops(0);
        });
}


function printShops(id) {

    const insertShopsList = document.querySelector('.js-load-shops');
    let shopsHtml = '';

    const filterShops = allShops.filter(e => {
        const catsId = e.categories.map(cats => cats.term_id);
        return id == 0 ? true : catsId.includes(parseInt(id)); 
    })

    filterShops.forEach(tienda => {
        const { title, acf } = tienda;

        shopsHtml += `
            <ul class="filter-shop__content swiper-slide">
                <li class="filter-shop__title">${title}</li> 
                <li class="c-tiendas__direccion">${acf.direccion.label + ': ' + acf.direccion.value}</li>
                <li class="c-tiendas__telefono"> ${acf.telefono.label + ': ' + acf.telefono.value}</li>
                <li class="c-tiendas__celular"> ${acf.celular.label + ': ' + acf.celular.value}</li>
                <li class="c-tiendas__schedule">${acf.horario_de_atencion.label + ': ' + acf.horario_de_atencion.value}</li>
                <li class="c-tiendas__schedule">${acf.email.label + ': ' + acf.email.value}</li>
            </ul>`;
    })

    insertShopsList.innerHTML = `<div class="filter-result js-swiper">
                                        <div class="filter-shop__e-container js-load-shops swiper-wrapper">
                                            ${shopsHtml}
                                        </div>
                                        <div class="swiper-button-prev"></div>
                                        <div class="swiper-button-next"></div>
                                    </div>`;

    runSlider();
}




function runSlider() {
    const swiper = new Swiper('.js-swiper', {
        initialSlide: 0,
        loopAdditionalSlides: 0,
        loopFillGroupWithBlank: true,
        slidesPerView: 1,
        breakpoints: {
            780: {
                slidesPerView: 1,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        allowTouchMove: true,
        speed: 500,
        autoHeight: true,
        spaceBetween: 15,
        grabCursor: true
    });
}


window.addEventListener('load', (event) => {
    const validation = document.querySelector('.find-shop');

    if (validation) {
        fetch(urlStates)
            .then(respuesta => respuesta.json())
            .then(resultado => {
                globalCategories = resultado
                getStatesAll();
            });

        onChangeListener();     //On change Departamento
        onChangeListenerCiudades();   //On change Ciudades
        getShops(); // get shopts
    }


});